module.exports = __webpack_public_path__ + "media/images/logo_webshop-blue_white@2x-8b70ba5d644f716798f3c8aed4ec7a9b.png";